import {
  TOGGLE_DMX_CONTROLLER_STATUS,
  TOGGLE_DMX_CONTROLLER_STATUS_SUCCESSFUL,
  TOGGLE_DMX_CONTROLLER_STATUS_FAILED,
} from './actionTypes';

const initialState = {
  toggleDmxControllerStatusError: null,
  messageDmxController: null,
  loadingToggleDmxControllerStatus: false,
};

const toggleControllerStatus = (state = initialState, action) => {
  switch (action.type) {
    case TOGGLE_DMX_CONTROLLER_STATUS:
      state = { ...state, loadingToggleDmxControllerStatus: true, toggleDmxControllerStatusError: null };
      break;
    case TOGGLE_DMX_CONTROLLER_STATUS_SUCCESSFUL:
      state = {
        ...state,
        loadingToggleDmxControllerStatus: false,
        messageDmxController: action.payload,
        toggleDmxControllerStatusError: null,
      };
      break;
    case TOGGLE_DMX_CONTROLLER_STATUS_FAILED:
      state = {
        ...state,
        messageDmxController: null,
        loadingToggleDmxControllerStatus: false,
        toggleDmxControllerStatusError: action.payload,
      };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default toggleControllerStatus;
